module.exports = __webpack_public_path__ + "img/icon_join_general.af042886.svg";